<div class="accordian-all-page sell-list" [ngClass]="customClass">
  <div class="main-content">
    <div class="row">
      <div class="cursor-pointer" (click)="onCardClick($event)">
        <div class="row py-3 align-items-center">
          <!-- Col 1: Contact / Supplier Name, Issue Date & Invoice No -->
          <div class="col-md-3">
            <div class="product-heading">
              <div class="position-relative tooltip-relative">
                <p class="mb-0 supplier-name" [title]="contactName">
                  {{ displayName }}
                </p>
              </div>

              <div class="d-flex align-items-center">
                <p class="mb-0 issue-date">
                  Issued On {{ invoice?.iqp_issue_date | dateFormat }}
                </p>
              </div>

              <div class="d-flex align-items-center position-relative">
                <p class="mb-0 small-invoice">
                  {{ labelPrefix || 'Invoice No' }}: {{ invoiceNumberDisplay }}
                </p>
              </div>

              <div class="position-absolute tooltip-amount" *ngIf="invoice?.iqp_invoice_number?.length > 14">
                <div class="custom-tooltip">
                  {{ invoice?.iqp_invoice_number }}
                </div>
              </div>
            </div>
          </div>

          <!-- Col 2: Due Date -->
          <div class="col-md-2 top-sm-1">
            <div class="product-heading d-flex justify-content-center flex-column">
              <h2 class="font-bold">DUE DATE</h2>
              <div class="d-flex align-items-center">
                <p class="inv-date mb-0">{{ invoice?.iqp_due_date || '-' }}</p>
                <span class="draft-badge ms-2 due-age" *ngIf="invoice?.daysPassed">
                  {{ invoice?.daysPassed }} Days Old
                </span>
              </div>
            </div>
          </div>

          <!-- Col 3: Payable Amount & Pie Chart Canvas -->
          <div class="col-md-4 top-sm-1 d-flex flex-column justify-content-center">
            <div class="product-heading cursor-pointer d-flex items-center justify-content-between align-items-center">
              <div class="w-60 payable-col">
                <div class="d-flex align-items-center justify-content-between">
                  <h2 class="w-60 font-bold">
                    {{ amountHeading || 'PAYABLE AMOUNT' }}
                  </h2>
                </div>
                <div>
                  <p class="inv-date w-60 mb-1 amount red">
                    {{ invoice?.amount | divide }}
                  </p>
                  <p class="inv-total-amt m-0">
                    Inv: {{ invoice?.iqp_total_final | divide }}
                  </p>
                </div>
              </div>

              <div class="product-heading inv-pie cursor-pointer tooltip-relative position-relative"
                *ngIf="showPieChart">
                <canvas [id]="pieChartId" width="50" height="50"></canvas>
              </div>
            </div>
          </div>

          <!-- Col 4: Status Badge -->
          <div class="col-md-1 top-sm-1 text-end">
            <div class="product-heading cursor-pointer tooltip-relative position-relative">
              <div class="draft-badge inv-badge ms-2" [ngClass]="statusBadgeClass">
                {{ statusDisplay }}
              </div>
            </div>
          </div>

          <!-- Col 5: Actions Menu Trigger -->
          <div class="col-md-2" *ngIf="showActionMenu">
            <div class="text-end d-flex justify-content-end">
              <app-action-menu headerText="Actions" xPosition="after">
                <ng-container *appHasAccess="accessPermission">
                  <app-action-menu-item *ngIf="isPaymentAllowed" icon="add" (clicked)="onAddPayment($event)">
                    Add Payment
                  </app-action-menu-item>
                  <app-action-menu-item *ngIf="showEditAction" icon="edit" (clicked)="onEdit($event)">
                    Edit
                  </app-action-menu-item>
                  <app-action-menu-item *ngIf="showDeleteAction" icon="delete" (clicked)="onDelete($event)">
                    Delete
                  </app-action-menu-item>
                  <app-action-menu-item *ngIf="invoice?.pdf_link && isDownloadPdfAllowed" icon="download" (clicked)="onDownloadPdf($event)">
                    Download PDF
                  </app-action-menu-item>
                </ng-container>
                <app-action-menu-item
                  *ngIf="invoice?.pdf_link && isCopyPdfAllowed"
                  icon="copy"
                  [copyValue]="invoice?.pdf_link"
                  (clicked)="onCopyPdfLink($event)"
                >
                  Copy To Clipboard
                </app-action-menu-item>

                <ng-container *ngIf="showCustomerDetails && invoice?.contact_id">
                  <app-action-menu-divider></app-action-menu-divider>
                  <app-action-menu-header>Connections</app-action-menu-header>
                  <app-action-menu-item icon="user" (clicked)="onCustomerDetails($event)">
                    Customer Details
                  </app-action-menu-item>
                </ng-container>
              </app-action-menu>
            </div>
          </div>
        </div>
      </div>

      <!-- Optional Projected Content for Accordion Expansion (e.g. payment history) -->
      <div class="p-15 accordian-border" *ngIf="isExpanded">
        <ng-content select="[expandedContent]"></ng-content>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
